import { useState } from "react";

import { registerService } from "../service-provider/ServiceRegistry";
import { TranslationContext } from "../translation/TranslationService";

function usePageTitle() {
  const [pageTitleKey, setPageTitleKey] = useState("");
  const [pageTitleContext, setPageTitleContext]: [TranslationContext | undefined, Function] =
    useState(undefined);

  return { pageTitleKey, pageTitleContext, setPageTitleKey, setPageTitleContext };
}

export default registerService(usePageTitle);
